<template>
  <footer>
    <div class="footer-grid">
      <div>
        <router-link class="brand" to="/"><img src="/assets/logo.webp" alt="VERVESTEEL"><span>VERVESTEEL<small>BUILDINGBETTER KITCHENS</small></span></router-link>
        <p class="pre-line">{{ $t('footer.slogan') }}</p>
        <span class="footer-company">{{ $t('footer.company') }}</span>
      </div>
      <div>
        <h3>{{ $t('footer.explore') }}</h3>
        <router-link v-for="item in explore" :key="item.path" :to="item.path">{{ item.label }}</router-link>
      </div>
      <div>
        <h3>{{ $t('footer.offer') }}</h3>
        <router-link v-for="item in productCategories" :key="item.id || item.key" :to="productCategoryRoute(item)">{{ item.name }}</router-link>
        <a :href="documents.productCatalog" target="_blank" rel="noopener noreferrer">{{ $t('footer.catalog') }} ↗</a>
      </div>
      <div>
        <h3>{{ $t('footer.build') }}</h3>
        <a class="footer-phone" href="tel:075584049606">0755-84049606</a>
        <a href="mailto:877808023@qq.com">877808023@qq.com</a>
        <p class="pre-line">{{ $t('footer.address') }}</p>
        <router-link to="/contact">{{ $t('footer.contact') }} ↗</router-link>
      </div>
    </div>
    <div class="footer-bottom"><span>© 2026 VERVESTEEL · {{ $t('footer.company') }}</span><span>{{ $t('footer.craft') }}</span></div>
  </footer>
</template>

<script>
import { documents } from '../data/site'
import { getCategories } from '../api/public'

export default {
  name: 'SiteFooter',
  data() { return { documents, categories: [] } },
  computed: {
    productCategories() {
      if (this.categories.length) return this.categories.slice(0, 4)
      return ['cooking', 'refrigeration', 'steel', 'western'].map(key => ({ key, name: this.$t(`footer.categories.${key}`) }))
    },
    explore() {
      return [
        { label: this.$t('common.about'), path: '/about' }, { label: this.$t('common.solutions'), path: '/solutions' },
        { label: this.$t('common.products'), path: '/products' }, { label: this.$t('common.cases'), path: '/cases' },
        { label: this.$t('common.service'), path: '/service' }, { label: this.$t('common.resources'), path: '/resources' }
      ]
    }
  },
  watch: {
    '$i18n.locale': 'loadCategories'
  },
  mounted() {
    this.loadCategories()
  },
  methods: {
    async loadCategories() {
      try {
        this.categories = await getCategories('PRODUCT') || []
      } catch (error) {
        this.categories = []
      }
    },
    productCategoryRoute(item) {
      return { path: '/products', query: item.id ? { categoryId: item.id } : { category: item.name } }
    }
  }
}
</script>
